import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation } from '../../types';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
import { getTranslatedApprovalType } from '../../utils/translationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuccessAlertI18nTitleText = ({
  approvalOperation
}) => {
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.updateAlertTitle.CREATE"
        });
      }
    case ApprovalOperation.APPROVE:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.updateAlertTitle.APPROVE"
        });
      }
    case ApprovalOperation.RECALL:
    case ApprovalOperation.CANCEL:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.updateAlertTitle.CANCEL"
        });
      }
    case ApprovalOperation.REJECT:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.updateAlertTitle.REJECT"
        });
      }
    case ApprovalOperation.REQUEST_CHANGES:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.updateAlertTitle.REQUEST_CHANGES"
        });
      }
    default:
      return unreachableFallback(approvalOperation, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.unhandled.approvalOperation"
      }));
  }
};
export const SuccessAlertI18nMessage = ({
  approvalOperation,
  approvalType,
  assetName
}) => {
  const approvalTypeName = getTranslatedApprovalType(approvalType);
  const options = {
    approvalType: approvalTypeName,
    assetName
  };
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.updateAlertMessage.CREATE",
          options: options
        });
      }
    case ApprovalOperation.APPROVE:
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.updateAlertMessage.APPROVE",
          options: options
        });
      }
    case ApprovalOperation.RECALL:
    case ApprovalOperation.CANCEL:
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.updateAlertMessage.CANCEL",
          options: options
        });
      }
    case ApprovalOperation.REJECT:
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.updateAlertMessage.REJECT",
          options: options
        });
      }
    case ApprovalOperation.REQUEST_CHANGES:
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "productApprovals.updateAlertMessage.REQUEST_CHANGES",
          options: options
        });
      }
    default:
      return unreachableFallback(approvalOperation, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.unhandled.approvalOperation"
      }));
  }
};